module.exports = __webpack_public_path__ + "img/buissness.c75cd02b.svg";